function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes, css } from 'styled-components';
import { MobileUserData } from './MobileUserData';
import { ScrollBarContainer } from '../../atoms/ScrollBarContainer/ScrollBarContainer';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext';
import { Text } from '../../atoms/Text';
import { IarrowRight2, InavigateLeft } from '../../atoms/AgroIcon/icons';
var MenuSlide = function MenuSlide(_ref) {
  var title = _ref.title,
    linkText = _ref.linkText,
    URL = _ref.URL,
    items = _ref.items,
    next = _ref.next,
    back = _ref.back,
    notifications = _ref.notifications,
    tagManager = _ref.tagManager;
  var _useContext = useContext(AgroHeaderContext),
    user = _useContext.user;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    level = _useState2[0],
    setLevel = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    moving = _useState4[0],
    setMoving = _useState4[1];
  var _useState5 = useState(true),
    _useState6 = _slicedToArray(_useState5, 2),
    isFirstOpen = _useState6[0],
    setIsFirstOpen = _useState6[1];
  var _useState7 = useState([]),
    _useState8 = _slicedToArray(_useState7, 2),
    text = _useState8[0],
    setText = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    categories = _useState0[0],
    setCategories = _useState0[1];
  var handleBack = function handleBack() {
    text.pop();
    setText(text);
    setLevel(level - 1);
    if (level - 1 === 0) {
      setCategories(false);
    }
    setMoving(true);
    back();

    // Handle animation
    setTimeout(function () {
      setMoving(false);
    }, 1);
  };
  var handleNext = function handleNext(evt, item) {
    if (!item.URL && !item.Children) {
      evt.preventDefault();
      return;
    }
    if (item.Children && item.Children.length === 0) {
      setMoving(true);
      return;
    }
    setIsFirstOpen(false);
    setMoving(true);
    if (item.ID === '249') {
      setCategories(true);
    }
    if (item.Children) {
      handleClickTrackEvent(item.Name);
      setText([].concat(_toConsumableArray(text), [item.Name]));
      setLevel(level + 1);
      next(evt, item);
      setTimeout(function () {
        setMoving(false);
      }, 1);
    } else {
      if (level === 1) {
        handleClickTrackEvent(item.Name);
      } else if (categories) {
        handleClickMenuHeader(item.Name);
      }
      next(evt, item);
    }
  };
  var handleClickTrackEvent = function handleClickTrackEvent(t) {
    var evtLabel = text.length ? [text, t].join(' - ') : t;
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'Navigation',
          eventAction: 'Hamburger',
          eventLabel: evtLabel
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var handleClickMenuHeader = function handleClickMenuHeader(t) {
    var textGTM = text.join('_', text);
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'menuHeader',
          category: "".concat(textGTM, "_").concat(t)
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var hasNotifications = function hasNotifications(item) {
    var conditions = [{
      url: '/myaccount/#/received',
      hasNotif: notifications.ReceivedUnread ? notifications.ReceivedUnread.count > 0 : false
    }, {
      url: '/myaccount/#/quotations/received',
      hasNotif: notifications['SELLER_PENDINGRESPONSE'] ? notifications['SELLER_PENDINGRESPONSE'].count > 0 : false
    }, {
      url: '/myaccount/#/sent',
      hasNotif: notifications.Sent ? notifications.Sent.count > 0 : false
    }, {
      url: '/myaccount/#/quotations/sent',
      hasNotif: notifications['BUYER_PENDINGACCEPTANCE'] ? notifications['BUYER_PENDINGACCEPTANCE'].count > 0 : false
    }];
    var found = conditions.find(function (cond) {
      return cond.url === item.URL && cond.hasNotif;
    });
    return found ? /*#__PURE__*/React.createElement(Notification, null) : null;
  };
  return moving ? null : /*#__PURE__*/React.createElement(MenuSlideContainer, {
    as: "ul",
    isFirstOpen: isFirstOpen
  }, title && title !== '' ? /*#__PURE__*/React.createElement(TitleItemStyled, {
    key: "title".concat(level)
  }, /*#__PURE__*/React.createElement(InavigateLeft, {
    fill: "white",
    onClick: function onClick() {
      return handleBack();
    }
  }), /*#__PURE__*/React.createElement(Text, {
    className: "label",
    type: "heading-xs",
    mr: "md"
  }, title)) : '', level === 0 && user && user.isLogged || level === 1 && title === ('Mi cuenta' || 'Minha conta' || 'Mi Cuenta' || 'Minha Conta') ? /*#__PURE__*/React.createElement(MobileUserData, {
    level: level
  }) : null, level === 0 && user && user.isLogged ? /*#__PURE__*/React.createElement(Separator, null) : null, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement(ItemStyled, {
      className: !item.Icon ? 'no-icon' : '',
      isLogged: user && user.isLogged,
      isTitle: level === 1 && !item.URL,
      key: "items-".concat(index, "-").concat(item.ID),
      level: level,
      title: title,
      onClick: function onClick(evt) {
        return handleNext(evt, item);
      }
    }, /*#__PURE__*/React.createElement(ItemLink, {
      href: item.URL,
      title: title,
      idx: index
    }, /*#__PURE__*/React.createElement(ItemName, null, item.Icon && item.Icon.length ? /*#__PURE__*/React.createElement("img", {
      src: item.Icon,
      alt: item.Name
    }) : null, /*#__PURE__*/React.createElement(Text, {
      type: level === 1 && !item.URL ? 'number-lg' : 'label-md'
    }, item.Name), notifications && hasNotifications(item)), /*#__PURE__*/React.createElement(ItemArrow, null, item.Children && item.Children.length > 0 ? /*#__PURE__*/React.createElement(IarrowRight2, {
      width: "16px",
      height: "16px"
    }) : '')));
  }));
};
MenuSlide.propTypes = {
  title: PropTypes.string,
  items: PropTypes.array,
  next: PropTypes.func,
  back: PropTypes.func,
  notifications: PropTypes.object,
  isAccount: PropTypes.bool
};
export { MenuSlide };

// Styles
var slide = keyframes(["0%{transform:translate(-100%);}100%{transform:translate(0px);}"]);
var MenuSlideContainer = styled(ScrollBarContainer).withConfig({
  displayName: "MenuSlide__MenuSlideContainer",
  componentId: "sc-1uk4kry-0"
})(["box-sizing:border-box;display:flex;flex-direction:column;list-style:none;margin:0;padding:0;overflow:auto;width:100%;animation:", ";height:auto;background-color:", ";@media (min-width:", "){display:none;}"], function (props) {
  return !props.isFirstOpen ? css(["", " 0.2s"], slide) : '';
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.white;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.breakpoint.lg;
});
var TitleItemStyled = styled.li.withConfig({
  displayName: "MenuSlide__TitleItemStyled",
  componentId: "sc-1uk4kry-1"
})(["align-items:center;background-color:", ";box-sizing:border-box;cursor:pointer;display:flex;justify-content:center;height:56px;padding:0 16px;position:relative;width:100%;z-index:1;.label{align-items:center;color:", ";line-height:44px;text-align:center;width:100%;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.green500;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.white;
});
var ItemStyled = styled.li.withConfig({
  displayName: "MenuSlide__ItemStyled",
  componentId: "sc-1uk4kry-2"
})(["background-color:", ";box-sizing:border-box;cursor:pointer;height:", ";padding:", ";position:relative;width:100%;border-style:hidden;a > div > span{color:", ";margin-left:", ";}", " &:nth-last-child(1){background-color:", ";a > div > span{color:", ";}}"], function (_ref6) {
  var theme = _ref6.theme,
    isTitle = _ref6.isTitle;
  return isTitle ? theme.colors.gray100 : theme.colors.white;
}, function (_ref7) {
  var isTitle = _ref7.isTitle;
  return isTitle ? '48px' : '44px';
}, function (_ref8) {
  var isTitle = _ref8.isTitle;
  return isTitle ? '8px 16px 0px 16px' : '0px 16px 0px 16px';
}, function (_ref9) {
  var theme = _ref9.theme,
    isTitle = _ref9.isTitle;
  return isTitle ? theme.colors.black : theme.colors.gray800;
}, function (_ref0) {
  var title = _ref0.title,
    isLogged = _ref0.isLogged;
  return title === ('Categorías' || 'Categorias') && isLogged ? '16px' : '0px';
}, function (_ref1) {
  var theme = _ref1.theme,
    level = _ref1.level;
  return level === 0 && css(["&:nth-child(3){background-color:", ";a > div > span{color:", ";}}"], function (_ref10) {
    var isLogged = _ref10.isLogged;
    return isLogged && theme.colors.gray100;
  }, function (_ref11) {
    var isLogged = _ref11.isLogged;
    return isLogged && theme.colors.blue600;
  });
}, function (_ref12) {
  var theme = _ref12.theme,
    title = _ref12.title,
    isLogged = _ref12.isLogged;
  return title !== ('Categorías' || 'Categorias') && isLogged && theme.colors.gray100;
}, function (_ref13) {
  var theme = _ref13.theme,
    title = _ref13.title,
    isLogged = _ref13.isLogged;
  return title !== ('Categorías' || 'Categorias') && isLogged && theme.colors.black;
});
var ItemLink = styled.a.withConfig({
  displayName: "MenuSlide__ItemLink",
  componentId: "sc-1uk4kry-3"
})(["display:flex;justify-content:space-between;align-items:center;color:", ";height:100%;text-decoration:none;border-style:hidden;border-top:", ";"], function (_ref14) {
  var theme = _ref14.theme;
  return theme.colors.gray800;
}, function (_ref15) {
  var theme = _ref15.theme,
    title = _ref15.title,
    idx = _ref15.idx;
  return title === ('Categorías' || 'Categorias') && idx !== 0 && "1px solid ".concat(theme.colors.gray500);
});
var ItemName = styled.div.withConfig({
  displayName: "MenuSlide__ItemName",
  componentId: "sc-1uk4kry-4"
})(["display:flex;align-items:center;> img{height:16px;margin:0 16px 0 0px;width:16px;}"]);
var ItemArrow = styled.div.withConfig({
  displayName: "MenuSlide__ItemArrow",
  componentId: "sc-1uk4kry-5"
})([""]);
var SecondIcon = styled.span.withConfig({
  displayName: "MenuSlide__SecondIcon",
  componentId: "sc-1uk4kry-6"
})(["right:44px;top:5px;position:absolute;> img{height:23px;width:67px;object-fit:cover;object-position:100% 0;}"]);
var Notification = styled.span.withConfig({
  displayName: "MenuSlide__Notification",
  componentId: "sc-1uk4kry-7"
})(["width:16px;height:16px;background-color:", ";border-radius:50%;margin:0px 10px 5px;"], function (_ref16) {
  var theme = _ref16.theme;
  return theme.colors.primary;
});
var Separator = styled.div.withConfig({
  displayName: "MenuSlide__Separator",
  componentId: "sc-1uk4kry-8"
})(["width:100%;height:16px;background-color:", ";"], function (_ref17) {
  var theme = _ref17.theme;
  return theme.colors.white;
});